import { Phone, CheckCircle2, MessageSquareText, Clock } from "lucide-react";
import { QuoteForm } from "./QuoteForm";
import { PHONE_DISPLAY, PHONE_HREF } from "./data";

const POINTS = [
  { icon: MessageSquareText, text: "Tell us what you need, big or small." },
  { icon: Clock, text: "We'll follow up with clear next steps." },
  { icon: CheckCircle2, text: "No-obligation quotes in plain language." },
];

export const Contact = ({ preselect }) => (
  <section id="contact" data-testid="contact-section" className="bg-brand-offwhite py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
      <div className="lg:pt-6">
        <p className="eyebrow">Contact JMS</p>
        <h2 className="h2 mt-4" data-testid="contact-heading">Let's Talk About Your Business Needs</h2>
        <p className="lead mt-4 max-w-md">Get clear advice and a solution that fits your business.</p>
        <a href={PHONE_HREF} data-testid="contact-call-button" className="btn-secondary mt-8">
          <Phone className="h-4 w-4" /> Call {PHONE_DISPLAY}
        </a>
        <ul className="mt-12 space-y-5">
          {POINTS.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-3.5 text-sm text-brand-navy">
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-lg border border-brand-surface bg-white"><Icon className="h-5 w-5 text-brand-blue" strokeWidth={1.6} /></span>
              {text}
            </li>
          ))}
        </ul>
      </div>
      <QuoteForm preselect={preselect} />
    </div>
  </section>
);
